export function MultiChainGamingIcon() {
  return (
    <svg
      width="335"
      height="196"
      viewBox="0 0 335 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_274_54)">
        <rect width="335" height="196" rx="14" fill="white" />
        <rect
          width="335"
          height="196"
          rx="14"
          fill="url(#paint0_radial_274_54)"
        />
        <path
          opacity="0.76"
          d="M42.1429 17.5455H42.2423L42.3341 17.5074L117.457 -13.5909H217.543L292.666 17.5074L292.758 17.5455H292.857H342.5V41.4545H292.992L217.894 -2.06896L217.777 -2.13636H217.643H117.357H117.223L117.106 -2.06896L42.0084 41.4545H-7.5V17.5455H42.1429ZM42.1429 -32.2727H42.1635L42.1841 -32.2744L117.378 -38.5H217.622L292.816 -32.2744L292.836 -32.2727H292.857H342.5V-8.36364H292.918L217.763 -27.0307L217.704 -27.0455H217.643H117.357H117.296L117.237 -27.0307L42.0817 -8.36364H-7.5V-32.2727H42.1429ZM217.643 223.045H217.704L217.763 223.031L292.918 204.364H342.5V228.273H292.857H292.836L292.816 228.274L217.622 234.5H117.378L42.1841 228.274L42.1635 228.273H42.1429H-7.5V204.364H42.0817L117.237 223.031L117.296 223.045H117.357H217.643ZM217.643 198.136H217.777L217.894 198.069L292.992 154.545H342.5V178.455H292.857H292.758L292.666 178.493L217.543 209.591H117.457L42.3341 178.493L42.2423 178.455H42.1429H-7.5V154.545H42.0084L117.106 198.069L117.223 198.136H117.357H217.643ZM217.643 160.773H217.742L217.834 160.735L292.957 129.636H342.5V141.091H292.857H292.723L292.606 141.158L217.508 184.682H117.492L42.3936 141.158L42.2773 141.091H42.1429H-7.5V129.636H42.0435L117.166 160.735L117.258 160.773H117.357H217.643ZM217.643 110.955H217.664L217.684 110.953L292.878 104.727H342.5V116.182H292.857H292.796L292.737 116.197L217.582 134.864H117.418L42.2634 116.197L42.204 116.182H42.1429H-7.5V104.727H42.1222L117.316 110.953L117.336 110.955H117.357H217.643ZM42.1429 79.8182H42.204L42.2634 79.8034L117.418 61.1364H217.582L292.737 79.8034L292.796 79.8182H292.857H342.5V91.2727H292.878L217.684 85.0471L217.664 85.0454H217.643H117.357H117.336L117.316 85.0471L42.1222 91.2727H-7.5V79.8182H42.1429ZM42.1429 54.9091H42.2773L42.3936 54.8417L117.492 11.3182H217.508L292.606 54.8417L292.723 54.9091H292.857H342.5V66.3636H292.957L217.834 35.2653L217.742 35.2273H217.643H117.357H117.258L117.166 35.2653L42.0434 66.3636H-7.5V54.9091H42.1429Z"
          fill="white"
          fillOpacity="0.1"
          stroke="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_274_54"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-347.803 291.958) rotate(-15.4288) scale(813.472 830.672)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <clipPath id="clip0_274_54">
          <rect width="335" height="196" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
